import { render, staticRenderFns } from "./KeyCapture.vue?vue&type=template&id=6424449e"
import script from "./KeyCapture.vue?vue&type=script&lang=ts"
export * from "./KeyCapture.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports